import IconAlt from './IconAlt';

export default IconAlt;
